import { render, staticRenderFns } from "./RsaConfigurazioneTurniModalEditComponent.vue?vue&type=template&id=bdb29e1e"
import script from "./RsaConfigurazioneTurniModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTurniModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports